import "react";

//#region src/components/slider/slider.utils.ts
const getMinMaxLabel = (label, val) => {
	if (label === true) return {
		value: val,
		label: val
	};
	return {
		value: val,
		label
	};
};
const buildContinuousSliderMarkArray = (marks, max, maxLabel, min, minLabel) => {
	const markArr = marks.map((mark) => ({ value: mark }));
	if (maxLabel) markArr.unshift(getMinMaxLabel(maxLabel, max));
	if (minLabel) markArr.unshift(getMinMaxLabel(minLabel, min));
	return markArr;
};
const buildDiscreteSliderMarkArray = (max, maxLabel, min, minLabel, step) => {
	const stepArr = [];
	for (let mark = step; mark <= max; mark += step) stepArr.push(mark);
	const markArr = stepArr.map((step$1) => ({ value: step$1 }));
	if (maxLabel) markArr.unshift(getMinMaxLabel(maxLabel, max));
	if (minLabel) markArr.unshift(getMinMaxLabel(minLabel, min));
	return markArr;
};

//#endregion
export { buildContinuousSliderMarkArray, buildDiscreteSliderMarkArray };